import React from 'react'
import BiddingMeeting from '../Cart/Cart'

const CartIndividual = () => {
  return (
    <div>
      <BiddingMeeting/>
    </div>
  )
}

export default CartIndividual
